var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMaintenance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.125 12.3125H13.4375V10.625H12.3125V12.3125H10.625V13.4375H12.3125V15.125H13.4375V13.4375H15.125V12.3125Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.875 17.375C10.4 17.375 8.375 15.35 8.375 12.875C8.375 10.4 10.4 8.375 12.875 8.375C15.35 8.375 17.375 10.4 17.375 12.875C17.375 15.35 15.35 17.375 12.875 17.375ZM12.875 9.5C11.0187 9.5 9.5 11.0187 9.5 12.875C9.5 14.7312 11.0187 16.25 12.875 16.25C14.7312 16.25 16.25 14.7312 16.25 12.875C16.25 11.0187 14.7312 9.5 12.875 9.5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 3.875C16.25 3.25625 15.7437 2.75 15.125 2.75H12.875V1.625H11.75V2.75H7.25V1.625H6.125V2.75H3.875C3.25625 2.75 2.75 3.25625 2.75 3.875V15.125C2.75 15.7437 3.25625 16.25 3.875 16.25H7.25V15.125H3.875V3.875H6.125V5H7.25V3.875H11.75V5H12.875V3.875H15.125V7.25H16.25V3.875Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaintenance);
export default __webpack_public_path__ + "static/media/maintenance.5386f791d04744192c8cc46f0eadf8b4.svg";
export { ForwardRef as ReactComponent };